/**
 * BlogLayout Component
 * Public layout for blog pages (no auth required)
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { cn } from '../../lib/utils';
import { LanguageSwitcher } from '../../components/blog';
import Footer from '../../components/footer/Footer';

const BlogLayout = ({ children }) => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-[#fbfaff]">
      {/* Header */}
      <header className="sticky top-0 z-50 border-b border-white/70 bg-white/80 shadow-[0_14px_40px_-32px_rgba(13,15,26,0.45)] backdrop-blur-xl">
        <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 sm:px-6 lg:px-8">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2">
            <img
              src="/brand/full-logo.png"
              alt="TRONA"
              className="h-10 w-auto"
            />
          </Link>

          {/* Right Section */}
          <div className="flex items-center gap-3">
            {/* Language Switcher */}
            <LanguageSwitcher />

            {/* CTA Button */}
            <Link
              to="/auth/sign-up/default"
              className={cn(
                'hidden rounded-full px-4 py-2 text-sm font-medium sm:inline-flex',
                'bg-primary-500 text-white',
                'hover:bg-primary-600 hover:text-white',
                'transition-colors duration-200'
              )}
            >
              {t('blog.startNow', 'Empezar ahora')}
            </Link>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="mx-auto max-w-7xl px-4 py-8 sm:px-6 sm:py-12 lg:px-8">
        {children}
      </main>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default BlogLayout;
